export default {
  en: {
    exit_reply_mode: 'Exit reply mode',
  },
};
